import { StateT } from "../../store";
import { PairFilterReduxT } from "./pairFilterReducers";

export const getPairFilter = (state: StateT): PairFilterReduxT => state.cap.pairFilter;
